import { styled, css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: calc(100% - 2.5rem);
  padding: 0.5rem;

  @media print {
    height: auto;
    overflow: visible;
    scrollbar-width: none;
    transform: none !important;
    -ms-overflow-style: none;
    padding-bottom: 5rem;
  }
`;

export const WeekRow = styled.div`
  display: grid;
  flex: 1;
  grid-template-columns: repeat(7, minmax(0, 1fr));

  @media print {
    break-inside: avoid;
    page-break-inside: avoid;
  }
`;

export const TopRow = styled.div`
  align-items: center;
  display: flex;
  gap: 0.5rem;
`;

export const MonthGridDayLabel = styled.span<{ $isToday: boolean }>`
  ${({ theme: { colors, fontSizes, fontWeights }, $isToday }) => css`
    color: ${$isToday ? colors.brandPrimary : colors.brandDarkTint30};
    display: block;
    font-size: ${fontSizes.s12};
    line-height: 1rem;
    margin: 0;
    text-transform: capitalize;
    user-select: none;

    strong {
      font-weight: ${fontWeights.medium};
    }

    @media print {
      padding-left: 0.5rem;
    }
  `}
`;

export const ExtraActionButton = styled.button<{ $isError?: boolean }>`
  ${({ theme: { colors, fontSizes, fontWeights }, $isError }) => css`
    align-items: center;
    background: transparent;
    border: none;
    color: ${$isError ? colors.semanticDanger : colors.brandDarkTint30};
    cursor: pointer;
    display: flex;
    font-size: ${fontSizes.s12};
    font-weight: ${fontWeights.medium};
    gap: 0.25rem;
    line-height: 1rem;
    padding: 0;
    text-align: left;
    user-select: none;

    b {
      color: ${colors.semanticDangerShade10};
      font-weight: ${fontWeights.medium};
    }

    &:hover {
      color: ${colors.brandPrimary};

      b {
        color: ${colors.brandPrimary};
      }
    }

    @media print {
      font-size: 0.6rem;
      opacity: 0.5;
      position: absolute;
      right: 2mm;
      top: 1mm;
    }
  `}
`;
